const navigationAccountRec = [
  {
    title: true,
    name: "Account Receivable",
    class: "",
    wrapper: {
      element: "",
      attributes: {}
    }
  },
  {
    name: "Preview",
    url: "/base/AccRecvPreview",
    icon: "icon-pencil"
  },
  {
    name: "Map Overview",
    url: "/base/AccRecvMap",
    icon: "icon-map"
  }
];

export default navigationAccountRec;
